define(['../modules/utils/i18n',
        'jquery',
        '../modules/usualPageSetup',
        'vhi-ui-framework/src/main/js/utilities/positioning',
        'shared/scripts/modules/services/ajaxHandler',
        'shared/scripts/modules/journeyPanelDynamicBehaviour',
        'shared/scripts/modules/contactPanel',
        'vhi-ui-framework/src/main/js/panels/customContentPanel',
        'vhi-ui-framework/src/main/js/panels/disablingLayer',
        'vhi-ui-framework/src/main/js/panels/analyticsData',
        'templates/landing/renewalsPanel.jade',
        '../modules/services/groupSchemeService',
        'vhi-ui-framework/src/main/js/layout/corporateFooter',
        'vhi-ui-framework/src/main/js/utilities/urls'
    ],
		

    function(i18n, $, usualPageSetup, positioning, ajaxHandler, journeyPanel, contactPanel, customContentPanel, disablingLayer, analyiticsData, renewalsPanelTemplate, groupSchemeService, footer, urlsUtils) {
        'use strict';

        disablingLayer.showDisablingLayer();

        var groupSchemeBasicInfoPromise;
        var i18nPromise;

        return {init: init};
        function init() {
            var groupSchemeToken = urlsUtils.getUrlParameter(window.location.href, "token");
            if (groupSchemeToken) {
                groupSchemeBasicInfoPromise = groupSchemeService.getGroupScheme(true, groupSchemeToken);
            } else {
                groupSchemeBasicInfoPromise = groupSchemeService.getGroupScheme(true);
            }
            i18nPromise = i18n.init();
            return $.when(groupSchemeBasicInfoPromise, i18nPromise)
                .then(usualPageSetup.init(true))
                .then(function (groupSchemeBasicInfoData, i18nData) {

                    populateAnalyitics(groupSchemeBasicInfoData);

                    var schemeName = groupSchemeBasicInfoData.schemeName;
                    var schemeNo = groupSchemeBasicInfoData.schemeId;
                    var vhiContactList = groupSchemeBasicInfoData.vhiContacts;
                    var isCustomEnrolmentFlag = groupSchemeBasicInfoData.customEnrolmentFlag;
                    var enableJourneyPanels = groupSchemeBasicInfoData.enableOnlineSales;

                    if (enableJourneyPanels) {
                        $('.journeysPanel').show();
                    }

                    if (groupSchemeBasicInfoData.showRenewals) {
                        $('#renewal-panel').replaceWith(renewalsPanelTemplate({}));
                    }

                    contactPanel.render(groupSchemeBasicInfoData);
                    positioning.applySameHeights();
                    journeyPanel.registerEventListeners(isCustomEnrolmentFlag, schemeNo, vhiContactList);
                    customContentPanel.populateCustomContent(schemeNo, 'groups',
                        $('#custom-content-dynamic-content'), showCustomContentHeader);

                    //userStory 2212, hide footer contacts in groups dashboard page
                    if ((vhiContactList && vhiContactList.length > 0) && ('WVC'===vhiContactList[0].roleType)) {
                        footer.hideContactDetails();
                    }

                    localizeStaticContent(schemeName, schemeNo);

                    disablingLayer.hideDisablingLayer();

                })
                .fail(function (e) {
                    //fallback - try to localize without scheme specific data
                    $('body').localize();
                    positioning.applySameHeights();
                    ajaxHandler.handleError(e);

                    disablingLayer.hideDisablingLayer();
                });
        }

        function showCustomContentHeader() {
            $('#custom-content-header').show();
        }

        function populateAnalyitics(groupSchemeBasicInfo) {
            analyiticsData.populateSchemeData({
                schemeId: groupSchemeBasicInfo.schemeId,
                schemeName: groupSchemeBasicInfo.schemeName,
                categoryId: groupSchemeBasicInfo.categoryId,
                categoryName: groupSchemeBasicInfo.categoryName
            });
        }

        function localizeStaticContent(schemeName, schemeNo) {
            $('body').localize();
            $('[class^=banner-panel]').localize({ groupName: schemeName, schemeNo: schemeNo });
        }

    }
);



//////////////////
// WEBPACK FOOTER
// ./src/main/scripts/pages/home.js
// module id = IwI5
// module chunks = 14